<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <v-navigation-drawer
      v-model="drawerOpen"
      app
      class="grey lighten-4 pl-2 pr-2 font-weight-light"
      clipped
      fixed
      stateless="stateless"
      temporary
      width="550"
    >
      <v-btn
        class="ml-3 v-btn--outlined"
        x-small
        @click="$store.commit('toggleAdvancedFilter', false)"
        >Advanced
      </v-btn>
    </v-navigation-drawer>
  </div>
</template>

<script>
  export default {
    name: 'advancedFilters',
    props: {
      visible: Boolean,
    },

    computed: {
      drawerOpen: {
        get() {
          this.$forceUpdate();
          return this.$store.state.tradeDSM.advancedFilterOpen;
        },
        set(v) {
          console.log(v);
        },
      },
    },
  };
</script>

<style scoped></style>
